import {
    BackArrow,
    BackButton,
    CTooltip,
    FillSpaceIphone,
    FilterButton,
    FilterText,
    Header,
    HeaderContainer,
    NotificationButton,
    NotificationCount,
    StyledLogo,
    Warning
} from './AppHeader.styled';
import {memo, useEffect, useRef, useState} from 'react';
import BurgerButton from '@components/Buttons/BurgerButton';
import {useAuthentication} from '@providers/AuthProvider';
import {useWindowSize} from 'react-use';
import {breakpoints} from '@styles/tokens';
import {useTheme} from '@emotion/react';
import {MenuType} from '@styles/themes';
import {useRouter} from 'next/router';
import FilterIcon from '@assets/svg/match/filter.svg'
import FilterOutlineIcon from '@assets/svg/match/filter-outline.svg'
import {useStore} from '@store/appStore';
import { useI18n } from '@i18n/useI18n';
import Tooltip from '@components/Tooltips/Tooltip';
import moment from 'moment';
import WarningPopup from '../WarningPopup';
import Notification_Icon from '@assets/svg/notification.svg'


const AppHeader = () => {
  const { setFilterOpen, filterDate, teams, settings, filterWarning, mobileLogin, client } = useStore();
  const { error, groups } = useAuthentication();
  const { width } = useWindowSize();
  const [showLogo, setShowLogo] = useState<any>();
  const theme = useTheme();
  const router = useRouter();
  const i18n = useI18n();
  const [warningActive, setWarningActive] = useState<boolean>(false);

  // pathname, not asPath: asPath includes the hash, and after the Microsoft login redirect that's a
  // long random #code=... which often contains "qr" by chance - the header then rendered differently
  // from the pre-rendered HTML (React #418/#423 on most web logins).
  let isSettings = router.pathname.includes("settings");
  let isNotification = router.pathname.includes("notification");
  const filterTimeOutRef = useRef(null)
  const mobile = false

  useEffect(() => {
    if (settings && settings.TEAMS)
    setShowLogo(settings.TEAMS)
  })

  useEffect(() => {
    if (filterTimeOutRef.current)clearTimeout(filterTimeOutRef.current)
    if(filterWarning){
      filterTimeOutRef.current = setTimeout(() => {
        setWarningActive(true)
        setTimeout(() => {
          setWarningActive(false)
        }, 18000);
      }, 3000);
    }
    else
    {
        setWarningActive(false)
    }
  }, [filterWarning])

  return (
    <Header>
      <FillSpaceIphone />
      <HeaderContainer>
        {showLogo && showLogo === "true" ? "" : <StyledLogo /> }

        {isSettings || isNotification?<BackButton onClick={() => window.history.back()}><BackArrow /></BackButton>:null}

       

        {groups?.length === 1 && groups?.includes(client?.GuardianGroupName) || router.pathname.includes("qr")?null:
          <>

            {teams?null:<FilterText isSettings={isSettings || isNotification}>
              {filterDate.text? <>
                {filterWarning?<Tooltip content={i18n.t('filter-text-custom-warning')} placement={"bottom-center"} offsetX={-4}>
                  <Warning />
                
                </Tooltip>:null}
                
                {warningActive && <WarningPopup click={setWarningActive} />}
              
                
              
                {filterDate.text.substring(12, 15) === "all"?<p>{i18n.t('filter-text-off')}</p>
                :<div>
                  <p><b>{i18n.t(filterDate.text, {year: filterDate.year})}</b></p>
                  <p>({moment(filterDate.from).format("DD-MM-YYYY") + " - " + moment(filterDate.enddate?filterDate.enddate:filterDate.to).format("DD-MM-YYYY")})</p>
                </div>}
              </>: null }
            </FilterText>}
              
            {teams || (mobile && mobileLogin < 2 || mobileLogin === undefined)?null:<CTooltip isSettings={isSettings} content={i18n.t("filter-tooltip")} placement={"bottom-center"} offsetX={-8}>
              <FilterButton onClick={() => setFilterOpen(true)}>
              
              
                {filterDate.text === null || filterDate.text.toLowerCase().substring(12, 15) === "all"? <FilterOutlineIcon /> : <FilterIcon /> }
              </FilterButton>
            </CTooltip>}



          </>}

        {/* <NotificationButton onClick={() => router.push("/notification")}>
          <Notification_Icon />
          <NotificationCount>{2}</NotificationCount>
        </NotificationButton> */}

        <BurgerButton isSettings={teams?isSettings:true} />
      </HeaderContainer>
    </Header>
  );
};

export default memo(AppHeader);
